import { render, staticRenderFns } from "./TabFluxoCaixa.vue?vue&type=template&id=563480fa&scoped=true&"
import script from "./TabFluxoCaixa.vue?vue&type=script&lang=js&"
export * from "./TabFluxoCaixa.vue?vue&type=script&lang=js&"
import style0 from "./TabFluxoCaixa.vue?vue&type=style&index=0&id=563480fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563480fa",
  null
  
)

export default component.exports